<div mat-dialog-title>Draw your signature here</div>
<div mat-dialog-content>
    <div class="signature-pad">
        <div class="signature-pad--body">
          <canvas #sPad [width]="canvasWidth" [height]="canvasHeight" style="touch-action: none;"></canvas>
        </div>
    </div>
</div>
<div mat-dialog-actions class="buttons">
    <button type="button" (click)="clear()" mat-flat-button>Clear</button>
    <button type="button" (click)="onSubmit()" mat-flat-button color="primary">Save</button>
</div>